<template>
  <SogPage title="GDV Zugänge">
    <SogCard>
      <SogCardActions>
        <SogCardActionButton
          ref="btnSearch"
          mdi-icon="mdi-plus"
          tooltip="Gdv-zugang anlegen"
          @click="onCreate"
        />
        <SogCardActionButton
          :kind="SogButtonKind.Refresh"
          @click="p_init"
        />
        <SogCardActionButton
          :kind="SogButtonKind.Back"
        />
      </SogCardActions>
      <SogCardContent>
        <GdvAccessListComponent
          :data="_gdvAccess"
          @edit-clicked="onEdit"
          @change-pin-clicked="onChangePin"
        />
      </SogCardContent>
    </SogCard>
  </SogPage>
</template>

<script setup lang="ts">
import SogPage from "@/shared/ui/SogPage.vue";
import GdvAccessListComponent from "@/modules/Gdv/components/GdvAccessListComponent.vue";
import {onMounted, ref} from "vue";
import GdvAccess from "@/shared/model/GdvAccess";
import {useSpinner} from "@/shared/composables/SogSpinner";
import apiGdv from "@/modules/Gdv/api";
import {useRouter} from "vue-router";
import {useNavigationStore} from "@/modules/Navigation/store";
import {useGdvStore} from "@/modules/Gdv/store";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {compareStrings} from "@/shared/utils/StringUtils";

const _gdvAccess = ref<GdvAccess[]>([]);
const _spinner = useSpinner();
const _router = useRouter();
const _navigationStore = useNavigationStore();
const _gdvStore = useGdvStore();


async function p_init() {

  try {
    _spinner.show()
    const res = await apiGdv.list();
    if (res) {
      _gdvAccess.value = res.sort((a, b) => compareStrings(a.id, b.id));
    }
  } finally {
    _spinner.hide()
  }
}

onMounted(async () => {
  await p_init()
})

function onEdit(value: GdvAccess) {
  if (value) {
    _navigationStore.currentGdvAccessId = value.id;
    _gdvStore.gdvAccess = value
    _router.push("/gdvacess/edit")
  }

}

function onCreate() {
  _gdvStore.gdvAccess = new GdvAccess();
  _router.push("/gdvacess/create")

}

function onChangePin(value: GdvAccess) {
  if (value) {
    _navigationStore.currentGdvAccessId = value.id;
    _gdvStore.gdvAccess = value
    _router.push("/gdvaccess_change_pin")
  }

}
</script>

<style scoped>

</style>
